import { action } from "satcheljs";
import type { FavoriteData } from "owa-favorites-types";

export interface ADD_TO_ORDERED_FAVORITE_ID_LISTActionMessage {
    favoriteData: FavoriteData;
}
export const addToOrderedFavoriteIdList: (favoriteData: FavoriteData) => ADD_TO_ORDERED_FAVORITE_ID_LISTActionMessage = action("ADD_TO_ORDERED_FAVORITE_ID_LIST", (favoriteData: FavoriteData): ADD_TO_ORDERED_FAVORITE_ID_LISTActionMessage => {
    return {
        favoriteData,
    };
});
